import { Dimensions, Platform, StyleSheet } from 'react-native';

import { Fonts } from 'assets/fonts';

import { COLOR, lightGrey } from 'utils/colors';
import {
    androidScreenMarginBottom,
    heightPercentageToDP,
    isTablet,
    isTabletOrWeb,
    landscapeAspectRatio,
    screenWidth,
    widthPercentageToDP,
} from 'utils/responsiveness';

const styles = StyleSheet.create({
    container: {
        paddingBottom: 40,
        width: isTabletOrWeb ? '100%' : undefined,
        minHeight: isTablet
            ? Dimensions.get('window').width / landscapeAspectRatio
            : undefined,
    },
    detailsPageContent: {
        marginTop: heightPercentageToDP(0, 85, 0),
        marginHorizontal: widthPercentageToDP(16, 44, 72),
        width: Platform.select({
            web: widthPercentageToDP(520),
            default: isTablet ? 400 : undefined,
        }),
        height: Platform.select({
            web: heightPercentageToDP(360),
            default: isTablet ? 280 : screenWidth * 1.05,
        }),
        justifyContent: 'flex-end',
    },
    marker: {
        marginLeft: isTabletOrWeb ? 0 : 6,
        marginRight: 12,
        height: 20,
        borderRadius: 20,
        alignSelf: isTablet ? 'flex-start' : 'center',
        justifyContent: 'center',
        alignItems: 'center',
    },
    contentMarkerIcons: {
        marginLeft: isTabletOrWeb ? 0 : 8,
        marginRight: isTabletOrWeb ? 12 : 8,
    },
    playbackButtons: {
        marginTop: 24,
    },
    playbackButtonFirst: {
        marginTop: 0,
    },
    playbackButton: {
        marginBottom: 24,
    },
    metadataText: {
        alignSelf: isTabletOrWeb ? 'flex-start' : 'center',
        fontFamily: Fonts.main.regular,
        fontSize: 14,
        color: lightGrey(0.7),
        textAlign: isTablet ? 'left' : 'center',
        marginBottom: heightPercentageToDP(16, 8, 8),
        lineHeight: 20,
    },
    noMarginText: {
        marginBottom: 0,
    },
    contentMarkers: {
        height: 20,
        alignItems: 'center',
        flexDirection: 'row',
        justifyContent: isTabletOrWeb ? 'flex-start' : 'center',
        marginBottom: heightPercentageToDP(8),
    },
    skeletonLoading: {
        marginTop: heightPercentageToDP(0, 104, 152),
        marginLeft: widthPercentageToDP(0, 44, 72),
        overflow: 'visible',
    },
    loading: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: COLOR.BLACK_OVERLAY(0.5),
    },
    errorDialog: {
        backgroundColor: COLOR.BLACK,
        marginBottom: androidScreenMarginBottom,
    },
    errorButtonText: {
        color: COLOR.background,
    },
    extraMarginCast: {
        marginTop: 24,
    },
});

export default styles;
